// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-textarea {
  position: relative;
  width: 100%;
  margin: 15px 0;
}
.custom-textarea .input-textarea {
  width: 100%;
  color: var(--sebrae-gray);
  font-weight: 400;
}
.custom-textarea .input-textarea label {
  display: block;
  font-size: 13px;
  line-height: 1.2;
  margin-bottom: 2px;
  color: var(--sebrae-gray);
}
@media screen and (min-width: 375px) {
  .custom-textarea .input-textarea label {
    font-size: 16px;
  }
}
.custom-textarea .input-textarea textarea {
  display: block;
  width: 100%;
  height: 116px;
  color: rgb(139, 153, 167);
  font-size: 16px;
  font-weight: 300;
  line-height: 16px;
  resize: none;
  background: var(--sebrae-white);
  border-radius: 4px;
  border: 1px solid var(--sebrae-light-gray5) !important;
  padding: 8px;
}
.custom-textarea .input-textarea textarea::placeholder {
  color: var(--sebrae-light-gray2);
}
.custom-textarea .input-textarea textarea:disabled {
  background: rgb(245, 247, 250);
  border: 1px solid rgb(182, 191, 200);
  color: rgb(182, 191, 200);
}`, "",{"version":3,"sources":["webpack://./src/components/textarea/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,yBAAA;EAEE,gBAAA;AAAN;AAGI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AADN;AAGM;EAPF;IAQI,eAAA;EAAN;AACF;AAEI;EACE,cAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;EAEE,eAAA;EACA,gBAAA;EAEF,iBAAA;EACA,YAAA;EACA,+BAAA;EACA,kBAAA;EACA,sDAAA;EACA,YAAA;AAFN;AAIM;EACE,gCAAA;AAFR;AAKM;EACE,8BAAA;EACA,oCAAA;EACA,yBAAA;AAHR","sourcesContent":[".custom-textarea {\n  position: relative;\n  width: 100%;\n  margin: 15px 0;\n\n  .input-textarea {\n    width: 100%;\n    color: var(--sebrae-gray);\n    font: {\n      weight: 400;\n    }\n\n    label {\n      display: block;\n      font-size: 13px;\n      line-height: 1.2;\n      margin-bottom: 2px;\n      color: var(--sebrae-gray);\n\n      @media screen and (min-width: 375px) {\n        font-size: 16px;\n      }\n    }\n    textarea {\n      display: block;\n      width: 100%;\n      height: 116px;\n      color: rgb(139, 153, 167);\n      font: {\n        size: 16px;\n        weight: 300;\n      }\n      line-height: 16px;\n      resize: none;\n      background: var(--sebrae-white);\n      border-radius: 4px;\n      border: 1px solid var(--sebrae-light-gray5) !important;\n      padding: 8px;\n\n      &::placeholder {\n        color: var(--sebrae-light-gray2);\n      }\n\n      &:disabled {\n        background: rgb(245, 247, 250);\n        border: 1px solid rgb(182, 191, 200);\n        color: rgb(182, 191, 200);\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
